import { Expose, Transform } from "class-transformer";

export class SuperviseOnCallDto {
  @Transform(({ value }) => value ?? "")
  @Expose()
  supervisionComment: string;
}
